module.exports = __webpack_public_path__ + "static/media/eject-icon.101403cf.svg";